import { BrowserRouter as Router, Route } from "react-router-dom";
import CreditApply from "./pages/creditApply/creditApply";
import Profile from "./pages/profile/profile";
import Detail from "./pages/detail";
import GuaranteeAdd from "./pages/guaranteeAdd/guaranteeAdd";
import GuaranteeWithdraw from "./pages/guaranteeWithdraw/guaranteeWithdraw";
import ApplyPost from "./pages/creditApply/post";
import Home from './pages/home'
import Nav from "./components/nav";
import GuaranteeAddPost from "./pages/guaranteeAdd/post";
import GuaranteeWithdrawPost from "./pages/guaranteeWithdraw/post";
import Login from "./pages/profile/login";
import { AuthProvider } from 'oidc-react';
import conf from './conf/config'
import Download from "./pages/download";

function App() {
  return (
    <AuthProvider {...conf.oidcConfig}>
      <Router>
        <div className="App">
          <Nav />
          <div className="box">
            <Route path="/creditApply" exact component={CreditApply} />
            <Route path="/creditApply/post" exact component={ApplyPost} />
            <Route path="/guaranteeAdd" exact component={GuaranteeAdd} />
            <Route path="/guaranteeAdd/post" exact component={GuaranteeAddPost} />
            <Route path="/guaranteeWithdraw" exact component={GuaranteeWithdraw} />
            <Route path="/guaranteeWithdraw/post" exact component={GuaranteeWithdrawPost} />
            <Route path="/profile" exact component={Profile} />
            <Route path="/download" exact component={Download} />
            {/* creditApply、guaranteeAdd、guaranteeWithdraw 公用一个详情，根据:type区别 */}
            <Route path="/detail/:type/:id" exact component={Detail} />
            {/* 登录页面路由必须为login-callback
            即使在配置中配置了其他回调路径，也不好使，不知道为什么，可能与sso服务端设置有关。 */}
            <Route path="/login-callback" exact component={Login} />
            <Route path="/" exact component={Home} />
          </div>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
